import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolUserRestriction from '../../../types/user-restriction'
import CreationToolWelcomeButton from '../../../types/welcome-button'
import Button from './button'

const Row = styled.div`
    display: flex;
    margin: 0 0 15px;
    width: 100%;
`

type Props = {
    className?: string
}

const CreationToolsWelcomeButtons = ({ className }: Props) => {
    const { tool, userRestrictionAccess } = useContext(CreationToolsContext)
    const buttons = CreationTool.welcomeButtons(tool)

    // filter out any buttons that have a user restriction
    const filteredButtons = buttons.filter((button) => {
        const restriction = CreationToolWelcomeButton.userRestriction(button)
        // filter out any buttons with restrictions not supported by current user
        return !restriction || CreationToolUserRestriction.hasAccess(restriction, userRestrictionAccess)
    })

    const firstRowButtons = filteredButtons.length > 3 ? filteredButtons.slice(0, 3) : filteredButtons
    const rowButtons = filteredButtons.length > 3 ? filteredButtons.slice(3) : []

    return (
        <div className={className}>
            <Row>
                {firstRowButtons.map((button) => (
                    <Button key={button} button={button} />
                ))}
            </Row>
            {rowButtons.map((button) => (
                <Row key={button}>
                    <Button key={button} button={button} horizontal />
                </Row>
            ))}
        </div>
    )
}

export default CreationToolsWelcomeButtons
